import {
  aMatchListItem,
  aMatchListItemPage,
  anItemMeta,
  mockMatchListItemsOperationQuery,
} from '__generated__';

const EXPIRATION_DATE = new Date().setFullYear(new Date().getFullYear() + 1);

export const MATCH_LIST_ITEM_DATA = {
  value: 'test match list item value',
  description: 'Test match list item description',
  expiration: new Date(EXPIRATION_DATE).toISOString(),
  updatedDescription: 'Test match list item description updated',
};

export const matchListItemsQuery = mockMatchListItemsOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        matchListItems: aMatchListItemPage({
          hasNextPage: false,
          objects: [
            aMatchListItem({
              id: '1',
              value: MATCH_LIST_ITEM_DATA.value,
              expiration: MATCH_LIST_ITEM_DATA.expiration,
              meta: anItemMeta({
                description: MATCH_LIST_ITEM_DATA.description,
              }),
            }),
          ],
          total: 1,
        }),
      })
    );
  }
);

export const matchListItemsQuery_updated = mockMatchListItemsOperationQuery(
  (_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        matchListItems: aMatchListItemPage({
          hasNextPage: false,
          objects: [
            aMatchListItem({
              id: '1',
              value: MATCH_LIST_ITEM_DATA.value,
              expiration: MATCH_LIST_ITEM_DATA.expiration,
              meta: anItemMeta({
                description: MATCH_LIST_ITEM_DATA.updatedDescription,
              }),
            }),
          ],
          total: 1,
        }),
      })
    );
  }
);

export const handlers = [
  mockMatchListItemsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        matchListItems: aMatchListItemPage({
          hasNextPage: false,
          objects: [],
          total: 0,
        }),
      })
    );
  }),
];
